import React, { PropTypes } from "react";
import moment from "moment";

const DateFormatter = ({ data }) => {
    return (
        <span>
            {moment(data, "YYYY-MM-DD").format("DD MMM YYYY").toString()}
        </span>
    );
};

export default DateFormatter;



// WEBPACK FOOTER //
// ./src/components/utils/TableUtils/DateFormatter.js